import CompanyExperienceError from './CompanyExperienceError'
export default CompanyExperienceError
